module.exports = __webpack_public_path__ + "static/media/presentation-sm.cfcc7816.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headers/presentation-sm.jpg
// module id = 158
// module chunks = 13